import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M28.281 6.281l1.438 1.438-18 18-.719.688-.719-.688-8-8 1.438-1.438L11 23.562z" /></svg>);